/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MovementProductValidationDTO {
  availableStock?: number;
  costPrice?: number;
  defaultImageUrl?: string;
  externalId?: number;
  inStockAcquisition?: number;
  inStockFidelization?: number;
  inStockInfluencerB4A?: number;
  inStockReserveMarketing?: number;
  internalEan?: string;
  invoicePrice?: number;
  millenniumSku?: string;
  productVariantId?: number;
  productVariantName?: string;
  stockBucket?: string;
  valid?: boolean;
  validationMessage?: string;
  validationStatus?: string;
  weight?: number;
}
